// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Rmj+G","title":"styles_title__U5o0q"};